import { Alert, Button, Col, Modal, Row, Table } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import { dateFormat } from '../../Utils/formatDate';


function Overtime() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);

    const titlePage = 'Overtime Data';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * page.pagination.pageSize + index },
        },
        {
            title: 'User Code',
            dataIndex: 'users_code',
            key: "users_code",
            render: (text, record) => {
                return record.users.users_code;
            }
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: "name",
            render: (text, record) => {
                return record.users.name;
            }
        },
        {
            title: 'Description',
            dataIndex: 'desc',
            key: "desc",
        },
        {
            title: 'Start Overtime',
            dataIndex: 'before_shift_overtime_duration',
            key: "before_shift_overtime_duration",
        },
        {
            title: 'End Overtime',
            dataIndex: 'after_shift_overtime_duration',
            key: "after_shift_overtime_duration",
        },
        {
            title: 'Start Break',
            dataIndex: 'before_shift_rest_duration',
            key: "before_shift_rest_duration",
        },
        {
            title: 'End Break',
            dataIndex: 'after_shift_rest_duration',
            key: "after_shift_rest_duration",
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: "status",
            render: (text, record) => {
                switch (record.status) {
                    case 'Approved':
                        return <b style={{ color: "#2E8B57" }}>{record.status}</b>;
                    case 'Rejected':
                        return <b style={{ color: "#FF4500" }}>{record.status}</b>;
                    default:
                        return <b style={{ color: "#00CED1" }}>{record.status}</b>;
                }
            }
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: "created_at",
            render: (text, record) => {
                if (record.created_at !== "")
                    return dateFormat(record.created_at);
                else
                    return "-";
            }
        },
        {
            title: 'Updated At',
            dataIndex: 'updated_at',
            key: "updated_at",
            render: (text, record) => {
                if (record.updated_at !== "")
                    return dateFormat(record.updated_at);
                else
                    return "-";
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                if (record.status !== 'Process' && record.status !== "") {
                    return '';
                } else {
                    return (
                        <>
                            <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('agree', record)}>
                                <b style={{ marginLeft: 5 }}>Approve</b>
                            </Button>
                            <Button type="primary" danger onClick={() => openModal('disagree', record)}>
                                <b style={{ marginLeft: 5 }}>Reject</b>
                            </Button>
                        </>
                    );
                }
            },
        },
    ];

    useEffect(() => {
        getApi("GET", '/overtime?search=' + search + '&page=' + page.pagination.current, 'overtime');
    }, [JSON.stringify(page), isAlert]);

    const getApi = (method, url, type) => {
        setLoading(true);

        const dataReq = {
            method: method,
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setData(res.data.data);
                setPage({
                    ...page,
                    pagination: {
                        ...page.pagination,
                        total: res.data.total_data
                    }
                });
                setLoading(false);
            } else {
                setLoading(false);
            }
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        })
    }

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setLoading(false);
                setIsAlert(true);
                setTextAlert(res.message);
            } else {
                setLoading(false);
                modalError(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        })
    }

    const openModal = async (type, data) => {
        if (type === 'agree') {
            Modal.confirm({
                title: 'NOTICE',
                content: 'Do you want to approve this data?',
                onOk: () => postApi('PUT', '/overtimeapproval/' + data.overtime_id, { status: 'Approved' }),
            });
        } else {
            Modal.confirm({
                title: 'NOTICE',
                content: 'Do you want to reject this data?',
                onOk: () => postApi('PUT', '/overtimeapproval/' + data.overtime_id, { status: 'Rejected' }),
            });
        }
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            ...sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    }


    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Overtime Data</h3>
            <Row>
                <Col span={8}>
                    <Search
                        placeholder="Search"
                        allowClear
                        enterButton="Search"
                        size="middle"
                        onSearch={searchData}
                    />
                    <br />
                    <br />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                </Col>
            </Row>
            <Table
                 size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />
        </div>
    );
}


export default Overtime;
